import Loadable from 'my-components/Loadable';

export const MCATSectionPage = Loadable(() => import(/* webpackChunkName: "mcat-section-page" */ './MCATSectionPage'));
export const MCATSectionBalancePage = Loadable(
  () => import(/* webpackChunkName: "mcat-section-page" */ './MCATSectionBalancePage'),
);
